import React, { useRef, useState, useEffect } from "react";
import { useGetCollaboratorsQuery } from "../../../app/features/apiSlice";
import Loader from "../../../components/Loader";
import Error from "../../../components/Error";
import { Badge, ButtonGroup, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import SetPageTitle from "../../../components/SetPageTitle";
import { Column } from "primereact/column";
import { Link, useParams } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../helpers";
import { apiSlice } from "../../../app/features/apiSlice";
import ExportCSVButton from "../../../components/exportcsv/ExportCsvButton";
import moment from "moment";
import SearchBox from "../../../components/SearchBox";
import ReusableDataTable from "../../../components/ReusableDataTable";

const initialSorting = {
  sortBy: "name",
  sortOrder: 1,
};

const ListCollab = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [sorting, setSorting] = useState(initialSorting);
  const sessionId = useRef(Date.now()).current;
  const { data, isLoading, isError, error, isFetching } =
    useGetCollaboratorsQuery({
      ...sorting,
      sessionId,
      searchQuery: searchQuery,
      page: currentPage,
      limit: 10,
    });

  const processItemForExport = (item) => {
    return {
      [t("name")]: `${item.user.first_name} ${item.user.last_name} `,
      [t("email")]: item.user.email,
      [t("mobilePhone")]: item.user.phone,
      [t("status")]: item.user.status ? "Active" : "Inactive",
      [t("kycStatus")]: item.user.kyc_status || "N/A",
    };
  };

  useEffect(() => {
    if (!isLoading) {
      const items = data?.data;
      const tableItem = [];
      if (items.length > 0) {
        items.forEach((item) => {
          tableItem.push({
            name:
              item?.user?.organizationUser?.type === "COMPANY"
                ? item?.user?.organizationUser?.company_name
                : `${capitalizeFirstLetter(
                    item?.user?.first_name,
                  )} ${capitalizeFirstLetter(item?.user?.last_name)}`.trim(),
            email: item?.user?.email,
            phone: item?.user?.phone,
            id: item?.user?.id,
            status: item?.status,
            kyc_status: item?.user?.kyc_status,
            createdAt: moment(item?.user?._date_register).format("DD-MM-YYYY"),
          });
        });
      }
      setTableData(tableItem);
    }
  }, [isLoading, data]);

  const totalRecords = data?.pagination?.total || 0;

  if (isLoading) return <Loader />;
  if (isError) return <Error error={error} />;
  return (
    <div className="my-3">
      <Card bg="dark1 text-light">
        <Card.Header className="d-flex justify-content-between align-items-center">
          <SetPageTitle title="collaborator" />
          <div className="d-flex justify-content-between align-items-center">
            <ExportCSVButton
              apiFn={apiSlice.endpoints.getCollaborators.initiate}
              processItem={processItemForExport}
              filenamePrefix="export_collaborator_list"
              queryParams={{
                sessionId,
                searchQuery,
                ...sorting,
              }}
            />
            <SearchBox
              setCurrentPage={setCurrentPage}
              setSearchQuery={setSearchQuery}
            />
          </div>
        </Card.Header>
        <Card.Body>
          <ReusableDataTable
            tableData={tableData}
            currentPage={currentPage}
            totalRecords={totalRecords}
            isLoading={isLoading}
            isFetching={isFetching}
            sorting={sorting}
            searchQuery={searchQuery}
            setSorting={setSorting}
            setCurrentPage={setCurrentPage}
            initialSorting={initialSorting}
          >
            <Column sortable field="name" header={t("form.name")}></Column>
            <Column sortable field="email" header={t("form.email")}></Column>
            <Column
              sortable
              field="phone"
              header={t("form.mobileNumber")}
            ></Column>
            <Column
              sortable
              header={t("status")}
              body={(rowData) => (
                <Badge
                  bg={`${
                    rowData.status === "Active" ? "success" : "secondary"
                  }`}
                >
                  {rowData.status === "Active" ? t("active") : t("inactive")}
                </Badge>
              )}
            ></Column>
            <Column
              sortable
              field="kyc_status"
              header={t("kycStatus")}
              body={(rowData) =>
                rowData.kyc_status !== null ? t(`${rowData.kyc_status}`) : "N/A"
              }
            ></Column>
            <Column sortable field="createdAt" header={t("createdAt")}></Column>
            <Column
              body={(rowData) => (
                <ButtonGroup size="sm">
                  <Link
                    to={`/${lang}/collaborator/${rowData.id}`}
                    className="btn btn-outline-light"
                  >
                    <i className="fa fa-eye" />
                  </Link>
                </ButtonGroup>
              )}
            ></Column>
          </ReusableDataTable>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ListCollab;
